// Open-source FingerprintJS — single visitorId per device. Used at signup to
// reject duplicate seller accounts on the same hardware. Not exposed to UI.
//
// The free library returns a stable hash of canvas + audio + WebGL + screen
// + timezone + fonts + plugins. Roughly 80% accurate; sufficient for MVP.
// Pro version ($200/mo, ~99.5%) is the upgrade path if abuse explodes.

import FingerprintJS from "@fingerprintjs/fingerprintjs";

let _fpPromise = null;

export async function getDeviceFingerprint() {
  if (!_fpPromise) {
    _fpPromise = FingerprintJS.load({ monitoring: false })
        .then((agent) => agent.get())
        .then((result) => result.visitorId);
  }
  return _fpPromise;
}
